import { FundClosingDrawdownStatusEnumType } from '__generated__/graphql';

export default function paymentStatusToReadable(status: FundClosingDrawdownStatusEnumType): {
  label: string;
  color: string;
} {
  switch (status) {
    case FundClosingDrawdownStatusEnumType.Cancelled:
      return {
        label: 'Cancelled',
        color: 'red',
      };
    case FundClosingDrawdownStatusEnumType.Transferred:
      return {
        label: 'Transferred',
        color: 'green',
      };
    case FundClosingDrawdownStatusEnumType.Pending:
      return {
        label: 'Pending',
        color: 'gray',
      };
    default:
      return {
        label: 'Unknown',
        color: 'gray',
      };
  }
}
